import { ErrorState } from "$components/error-state";
import type { FC } from "react";

export const MultipleTabsErrorPage: FC = () => (
  <ErrorState
    title="ePOCUS is already open in another tab"
    body="To continue here, close any other open tabs. This keeps clinical records safe and consistent."
    showRetry={false}
  />
);
